import { OpenFeature } from "@openfeature/web-sdk";
import { clientEnv } from "./client-env";

const featureFlagClient = OpenFeature.getClient("product-app");

function resolveBrowserOverrides() {
  const raw = clientEnv.VITE_OPENFEATURE_FLAG_OVERRIDES;
  if (typeof raw !== "string" || raw.length === 0) {
    return {} as Record<string, boolean>;
  }

  try {
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    return Object.fromEntries(
      Object.entries(parsed).filter(
        (entry): entry is [string, boolean] => typeof entry[1] === "boolean",
      ),
    );
  } catch {
    return {} as Record<string, boolean>;
  }
}

const overrideMap = resolveBrowserOverrides();

export function getBooleanFlagSync(flagKey: string, defaultValue: boolean) {
  if (typeof overrideMap[flagKey] === "boolean") {
    return overrideMap[flagKey];
  }

  return defaultValue;
}

export async function getBooleanFlag(flagKey: string, defaultValue: boolean) {
  if (typeof overrideMap[flagKey] === "boolean") {
    return overrideMap[flagKey];
  }

  try {
    return await featureFlagClient.getBooleanValue(flagKey, defaultValue);
  } catch {
    return defaultValue;
  }
}
